<template>
  <div class="success">
    <img src="/web/img/visa-mobile/trx-success.svg" alt="Sukces" />
  </div>
</template>

<script>
export default {
  name: 'VisaMobileStatusSuccess'
}
</script>

<style lang="scss" scoped>
@import "./src/base/assets/scss/components/_visamobile-loader.scss";
</style>
